"use client";

import Link from "next/link";
import { memo, useState } from "react";

import MemoModal from "components/MemoModal";
import { MemoInput } from "components/MemoModal/MemoModal";
import VisibilityTag from "components/VisibilityTag";
import { LessorPropertyList } from "graphql/type";

const tailwindPlaceCenter = "flex items-center px-4";

const ParkingTableRow = memo(
  ({
    parkingLotData: { id, name, address, images, controlNumber, remarks, availability, officer, visibility, memo },
    updateMemo,
  }: {
    parkingLotData: LessorPropertyList;
    updateMemo: (id: string, memo: string) => void;
  }) => {
    const [openMemoModal, setOpenMemoModal] = useState(false);

    const handleOpenMemoModal = (e: React.MouseEvent<HTMLDivElement>) => {
      // If click memo, open memo modal and prevent Link parent
      e.preventDefault();

      // Open memo modal
      setOpenMemoModal(true);
    };

    const handleCloseMemo = () => {
      setOpenMemoModal(false);
    };

    const handleUpdateMemo = async ({ memo }: MemoInput) => {
      await updateMemo(id ?? "", memo);

      // Close memo modal
      handleCloseMemo();
    };

    return (
      <>
        <Link
          href={`/property/${id}`}
          className="mb-[4px] grid min-h-[74px] w-full grid-cols-table rounded border border-border bg-white px-2 py-2  shadow-table hover:border-gray"
        >
          <div className={`flex items-center gap-4 border-r`}>
            <img
              src={images?.url != null && images.url.length > 0 ? (images.url[0] as string) : "/svg/noImage.svg"}
              alt={name ?? "no-image"}
              className="h-[58px] min-w-[80px] max-w-[80px] rounded object-cover"
            />
            <div>
              <p>{name ?? ""}</p>
              <p className="text-xs text-gray">{address}</p>
            </div>
          </div>
          <div className={`border-r text-14px ${tailwindPlaceCenter}`}>{controlNumber}</div>
          <div className={`text ${tailwindPlaceCenter} border-r text-12px`}>{remarks}</div>
          <div className={`border-r ${tailwindPlaceCenter} text-14px font-bold text-blue`}>
            {availability?.emptySpace ?? 0}台
          </div>
          <div className={`border-r ${tailwindPlaceCenter} text-14px font-bold text-red`}>
            {availability?.occupiedSpace ?? 0}台
          </div>
          <div className={`flex items-center border-r px-4 text-14px`}>{officer?.fullname}</div>
          <div className={`${tailwindPlaceCenter} border-r`}>
            <VisibilityTag visibility={visibility} />
          </div>
          <div className="flex items-center px-4 py-[10px]">
            <div
              className={`${tailwindPlaceCenter} h-[38px] min-w-[80px] gap-2 px-[16px] py-[9px] hover:bg-link-light`}
              onClick={handleOpenMemoModal}
            >
              <img src={`/svg/${memo ? "updateMemo" : "addMemo"}.svg`} alt="IconMemo" />
              <span className="text-12px text-link">メモ</span>
            </div>
          </div>
        </Link>

        <MemoModal isOpen={openMemoModal} onClose={handleCloseMemo} onConfirm={handleUpdateMemo} memo={memo ?? ""} />
      </>
    );
  }
);

ParkingTableRow.displayName = "ParkingTableRow";

export default ParkingTableRow;
